import image from "../Assets/image.jpg";
import Man from "../Assets/Man.jpg";
import folder from "../Assets/folder.png";
import Teddy from "../Assets/Teddy.jpg";
import Tommy from "../Assets/Tommy.jpg";
import Peacock from "../Assets/Peacock.jpg";
import Fri from "../Assets/Fri.jpg";
import Flower from "../Assets/Flower.jpg";
import PdfIcon from "../Assets/PdfIcon.png";
import Excel from '../Assets/Excel.png';
import Video from '../Assets/video.png';
import GenericIcon from '../Assets/GenericIcon.png';
import Document from '../Assets/Document.png';
import Audio from '../Assets/Audio.png';
import psd from '../Assets/psd.jpg';

export function getFileIcon(fileName,url) {
  const ext = fileName?.split('.').pop().toLowerCase();

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
  const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv'];
  const audioExtensions = ['mp3', 'wav', 'aac', 'ogg', 'm4a'];
  const pdfExtensions = ['pdf'];
  const wordExtensions = ['doc', 'docx'];
  const excelExtensions = ['xls', 'xlsx'];
  const pptExtensions = ['ppt', 'pptx'];
  const zipExtensions = ['zip', 'rar', '7z'];
  const codeExtensions = ['js', 'ts', 'jsx', 'tsx', 'html', 'css', 'json'];
  const psdExtension = ['psd'];

  if (imageExtensions.includes(ext)) return url;   
  if (videoExtensions.includes(ext)) return Video;   
  if (audioExtensions.includes(ext)) return  Audio;   
  if (pdfExtensions.includes(ext))   return PdfIcon;  
  if (wordExtensions.includes(ext))  return Document;   
  if(psdExtension .includes(ext))  return psd;
  if (excelExtensions.includes(ext)) return Excel;   
  if (pptExtensions.includes(ext))   return '📈';  
  if (zipExtensions.includes(ext))   return '🗜️';   
  if (codeExtensions.includes(ext))  return '💻';   

  return folder;
}



